import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import TaskMapForm from '../TaskMapForm/TaskMapForm';
import TaskMapDescription from '../TaskMapDescription/TaskMapDescription';
import './TaskMapView.less';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import {
  refreshCanEditGeometry,
  selectCurrentTask,
  selectNotDataTask,
  setCanEditGeometries,
} from '../../../store/slice/taskSlice';
import { ReactComponent as RightCircle } from '../../../res/svg/right-circle.svg';
import { ReactComponent as LeftCircle } from '../../../res/svg/left-circle.svg';
import Task from '../../../models/Task';
import { loadGeometries } from '../../../store/slice/mapSlice';
import { stateTask, rolPermission } from '../../../utils/functions';
import { setAddingMultipleFeatures } from '../../../store/slice/mapLayersSlice';
import { setAddingAOI } from '../../../store/slice/mapAOISlice';

interface Props {
  editing: boolean;
  onOpenChange: (open: boolean) => void;
}

function TaskMapView({ editing, onOpenChange }: Props) {
  let urlParams = useParams();
  const [loading, setLoading] = useState<boolean>(urlParams.id !== undefined);
  const [open, setOpen] = useState<boolean>(true);
  const currentTask = useAppSelector(selectCurrentTask);
  const notData = useAppSelector(selectNotDataTask);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  //@ts-ignore
  const currentUser: User = JSON.parse(localStorage.getItem('currentUser'))

  const showTaskInformation = (showInfo: boolean, task: Task) => {
    navigate((showInfo ? '/tareas/visualizar/' : '/tareas/editar/') + (task ? task.id : urlParams.id))
  };

  const notEdit = (currentTask?.isClosable ||
    currentTask?.estado === stateTask.CERRADA ||
    (currentUser.rol !== null && currentUser.rol.permiso === rolPermission.SUPERVISION))

  const showTaskForm = (show: boolean) => {
    navigate((show ? '/tareas/editar/' : '/tareas/visualizar/') + urlParams.id)
  };

  useEffect(() => {
    if(editing){
      dispatch(refreshCanEditGeometry())
      if(notEdit){
        navigate('/tareas');
      }
    } else{
      dispatch(setAddingMultipleFeatures(false))
      dispatch(setAddingAOI(false))
      dispatch(setCanEditGeometries(false))
    }
  }, [editing, currentTask])

  useEffect(() => {
    if (currentTask) {
      setLoading(false);
      dispatch(loadGeometries())
    } else if(notData){
      //si no existe la tarea redirecciona a la url tareas
      setTimeout(() => {
        navigate('/tareas');
      }, 350);
    }
  }, [currentTask, notData]);

  return (
    <div className={'tp-task-map__container ' + (open ? 'open' : '')}>
      <div className='tp-task-map__arrow-container'>
        {
          open ?
            <LeftCircle onClick={() => {
              setOpen(false);
              onOpenChange(false);
            }} />
            :
            <RightCircle onClick={() => {
              setOpen(true);
              onOpenChange(true);
            }} />
        }
      </div>
      {open ? (
        loading ? (
          <div className='tp-task-map__form__loading'>
            <Spin indicator={<LoadingOutlined spin />} />
          </div>
        ) : editing ? (
         <TaskMapForm task={currentTask ?? {}} key={currentTask?.id ?? 0} showTaskInformation={showTaskInformation} />
        ) : currentTask ? (
          <TaskMapDescription task={currentTask} showTaskForm={showTaskForm} />
        ) : null
      ) : null}
    </div>
  );

}

export default TaskMapView;
